import { Outlet } from 'react-router-dom';
import styled from 'styled-components';
import Navbar from './Navbar';
import Footer from './Footer';

const Principal = styled.main`
  min-height: 60vh;
`;

export const Contenedor = styled.div`
  max-width: ${({ theme }) => theme.maxWidth};
  margin: 0 auto;
  padding: ${({ theme }) => theme.space.xl} ${({ theme }) => theme.space.md};
`;

export const TituloPagina = styled.h1`
  font-size: clamp(1.9rem, 4vw, 2.6rem);
  color: ${({ theme }) => theme.colors.sageDeep};
  margin-bottom: ${({ theme }) => theme.space.sm};
`;

export const Subtitulo = styled.p`
  color: ${({ theme }) => theme.colors.textMuted};
  max-width: 60ch;
  margin-bottom: ${({ theme }) => theme.space.xl};
`;

function Layout() {
  return (
    <>
      <Navbar />
      <Principal>
        <Outlet />
      </Principal>
      <Footer />
    </>
  );
}

export default Layout;
